import router from "../../router"


export const productClick = {
	methods: {
		productClick(itemObj) {
			console.log("handleClickBtn ", itemObj);
			localStorage.setItem("shisuanBack", window.location.href);
			// this.$router.replace({
			//   path: "/financingDetail",
			//   query: { productNo: itemObj.productNo, status: itemObj.status, productNature: itemObj.productNature, loanLimit:itemObj.loanLimit },
			// });
			// console.log(ptojectType)
			var _this = this;
			if (itemObj.productNature == 1) {
				let dkId = localStorage.getItem("dkId");

				//第三方产品
				if (dkId) {
					this.$common.infoSubmit('/app/check/routePage', {
						dkId: localStorage.getItem("dkId"),
						productNo: itemObj.productNo
					}, (res) => {

						// console.log(itemObj, res.isSkip, "wwwww", )
						let data = {
							productNo:itemObj.productNo,
							dkId:localStorage.getItem("dkId"),
							applyTime:this.$common.getNowTime(),
							phone:localStorage.getItem("phoneNum")
						}
						// 第一次点击第三方产品，贷小二记录
						this.$common.infoSubmit("/app/product/addProductApplyLog",data,res=> {})
						if (itemObj.capitalName == "中国农业银行" && res.isSkip !== "0") {
							localStorage.setItem('creditAmount',res.creditAmount)
							this.$router.replace({
								path: '/agriculturalBank'
							})
						} else if(itemObj.productName == '提钱花') {
							setTimeout(()=> {
								window.location.href = itemObj.thirdProductLink
								// location.replace(itemObj.thirdProductLink)
							},1000)
						} else {
							if (itemObj.status == 7) {
								_this.$common.getProjectUrl(itemObj, "shenqing");
							} else {
								_this.$common.getProjectUrl(itemObj, "yongkuan");
							}
						}
					})


					return

					// this.$common.infoSubmit(
					//   "/app/auth/status",
					//   { dkId: localStorage.getItem("dkId") },
					//   (res) => {
					//     // console.log(res)
					//     if (res.status == 0) {
					//       //未认证
					//       localStorage.setItem("livingToPage", window.location.href);
					//       _this.$refs.popup.isPageShow = true;
					//     } else {
					//       //已认证
					//       // this.$common.pageEventHandle({eventType: 11, productNo: itemObj.productNo});
					//       // this.$common.pageEventHandle({eventType: 12, productNo: itemObj.productNo});
					//       if (itemObj.status == 7) {
					//         _this.$common.getProjectUrl(itemObj, "shenqing");
					//       } else {
					//         _this.$common.getProjectUrl(itemObj, "yongkuan");
					//       }
					//       // this.$common.getData("/app/product/applyAgentProductAndUrl", {dkId:localStorage.getItem('dkId'),productNo:itemObj.productNo}, function (res) {
					//       //   // console.log(JSON.stringify(res));
					//       //   window.location.href=res;
					//       //   // window.open(res, "_blank");
					//       // });
					//     }
					//   }
					// );
				} else {
					localStorage.setItem("jumpLogin", window.location.href)
					router.replace({
						path: "/login"
					});
				}
			} else {
				//自营产品
				localStorage.setItem("shisuanBack", window.location.href);
				this.$router.replace({
					path: "/financingDetail",
					query: {
						productNo: itemObj.productNo,
						suggestedIdentity: itemObj.suggestedIdentity,
						suggestedType: itemObj.suggestedType,
					},
				});
			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/mixins/productClick/index.js